import {
  AppBar,
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  ListItem,
  Toolbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useFormContext } from "react-hook-form";
import Label from "../../../libs/rhf-mui/ui/Label";
import { Lang, SpwkUtil } from "../../dao/SpwkUtil";
import { SpwkUtilV3 } from "../../dao/SpwkUtilV3";
import { InputToken, UniOption } from "../../dao/UniOption";
import { useGV } from "../../GV";
import { R } from "../../R";
import UcUniInput from "./UcUniInput";
import UcUniText from "./UcUniText";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import {
  AppContextProps,
  useAppContext,
} from "../../../libs/app-core/AppContext";
import { MessageDialog } from "../../../libs/app-core/dialogs/MessageDialog";
import FrmCareerSelector from "../../pages/FrmDialogTest/FrmCareerSelector";
import { useState } from "react";
import { Member } from "../../dao/Member";
import MenuOpenSharpIcon from "@mui/icons-material/MenuOpenSharp";
import { uniProfession } from "../../dao/Profession";
import { useTranslation } from "react-i18next";
import { isConstructorDeclaration } from "typescript";

type Props = {
  uni_option: UniOption;
  member: Member | null | undefined;
  LangA: Lang;
  LangB: Lang;
};

const UcOptionLabel = ({ uni_option, member, LangA, LangB }: Props) => {
  const { t } = useTranslation();

  let title_a = uni_option.option_title ? t(uni_option.option_title) : "";
  let title_b = uni_option.getTitleLangB(LangB) ?? "";

  // if (
  //   "去迪斯可舞廳、卡啦OK或流行音樂會" === "去迪斯可舞廳、卡啦OK或流行音樂會"
  // ) {
  //   title_a = t("去迪斯可舞廳、卡啦OK或流行音樂會");
  //   console.log("uni_option", uni_option);
  // }

  const { token_list } = SpwkUtil.CreateInputTokens(uni_option, title_a);
  const [open, setOpen] = useState(false); // dialog開關
  const [selectedProfession, setSelectedProfession] = useState<uniProfession>(); //被選到的職業資料
  const ctx = useAppContext();
  const GV = useGV();
  function handleCloseCareerSelector() {
    setOpen(false);
  }
  function handleOpenCareerSelector() {
    setOpen(true);
  }
  function handleSelectProfession(selectedProfession: uniProfession) {
    setSelectedProfession(selectedProfession);
  }
  function handleSaveCareerSelector() {
    setSelectedProfession(selectedProfession);
    handleCloseCareerSelector();
    form_ctx.setValue(
      "作業經歷.目前從事●目前從事●input_1",
      selectedProfession?.professionName
    );
    form_ctx.setValue(
      "作業經歷.職業代碼●●input_1",
      selectedProfession?.professionCode
    );
  }
  //#region 勾選的項目高亮顯示
  const form_ctx = useFormContext();
  let is_option_selected = false;
  if (uni_option.question_kind === SpwkUtilV3.Q_KIND_多選) {
    is_option_selected = form_ctx.watch(uni_option.get_Option_RhfName());
  } else if (uni_option.question_kind === SpwkUtilV3.Q_KIND_單選) {
    if (uni_option.OwnerQuestion != null) {
      is_option_selected =
        uni_option.option_code ===
        form_ctx.watch(uni_option.OwnerQuestion?.get_Question_RhfName());
    }
  }
  //#endregion

  return (
    <>
      <Box>
        <Grid container alignItems={"center"}>
          {render_Tokens(token_list, LangA, LangB)}
        </Grid>
        {LangB !== "" ? (
          <Label variant="caption" color="text.disabled">
            {" "}
            {title_b}{" "}
          </Label>
        ) : undefined}
      </Box>
      <div>
        <Dialog open={open}>
          <AppBar sx={{ position: "relative" }}>
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleCloseCareerSelector}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                {t("職業選擇")}
              </Typography>
              <Button
                autoFocus
                color="inherit"
                onClick={handleSaveCareerSelector}
              >
                {t("儲存")}
              </Button>
            </Toolbar>
          </AppBar>
          <ListItem>
            <FrmCareerSelector onSelectProfession={handleSelectProfession} />{" "}
            {/* 將回調函數傳遞給 FrmCareerSelector */}
          </ListItem>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseCareerSelector}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
        </Dialog>
      </div>
    </>
  );

  function render_Tokens(
    token_list: (string | InputToken)[],
    LangA: Lang,
    LangB: Lang
  ) {
    let ui_list = [];
    //#region DEBUG 用顏色
    let color = uni_option.is_split_parent === 1 ? "#f48fb1" : undefined;
    if (
      uni_option.split_from_option_guid !== "" &&
      (GV.IsAdmin() ?? false) === true
    ) {
      // 拆分顏色
      color = "#d500f9";
    }
    //#endregion

    if (is_option_selected === true) {
      color = R.color.option_selected;
    }
    if (token_list.length !== 0) {
      let ii = 0;
      for (let token of token_list) {
        if (typeof token === "string") {
          // 繪製文字
          if (token.trim() === t("呼吸困難")) {
            //如果有第三個類似情況考慮別種寫法, 呼吸困難是 B2 和 B29 的題目
            ui_list.push(
              <UcUniText
                key={ii}
                text={token}
                margin_right={"6px"}
                fore_color={color}
                bold={is_option_selected}
                variant={uni_option.variant}
              />
            );
            ui_list.push(
              <HelpOutlineIcon
                key={ii + "icon"}
                sx={{ ml: 2, color: { color } }}
                onClick={(e) => {
                  help_outline_icon_click(ctx);
                }}
              />
            );
          } else if (
            token.trim() === t("目前從事") &&
            member?.spwk_uni_func_guids.includes("A98")
          ) {
            //這邊找到目前從事+A98
            ui_list.push(
              <UcUniText
                key={ii}
                text={token}
                margin_right={"6px"}
                fore_color={color}
                bold={is_option_selected}
                variant={uni_option.variant}
              />
            );
            ui_list.push(
              <MenuOpenSharpIcon
                key={ii + "icon"}
                sx={{ ml: 2, color: { color } }}
                onClick={(e) => {
                  handleOpenCareerSelector();
                }}
              />
            );
          } else {
            //核心
            ui_list.push(
              <UcUniText
                key={ii}
                text={token}
                margin_right={"6px"}
                fore_color={color}
                bold={is_option_selected}
                variant={uni_option.variant}
              />
            );
          }
        } else {
          // 繪製元件
          let input_token = token as InputToken; // 包含繪製 input 的資訊，再交由 UcUniInput 繪製
          let uni_input = (
            <UcUniInput
              key={ii}
              uni_option={uni_option}
              input_token={input_token}
              margin_right={"6px"}
              LangA={LangA}
              LangB={LangB}
            />
          );
          ui_list.push(uni_input);
        }
        ii++;
      }

      return <>{ui_list}</>;
    } else {
      return (
        <UcUniText
          key={"0"}
          text={title_a}
          margin_right={"6px"}
          fore_color={color}
          bold={is_option_selected}
          variant={uni_option.variant}
        />
      );
    }
  }

  function help_outline_icon_click(ctx: AppContextProps) {
    let color = R.color.subtitle_blue;
    MessageDialog.Show(
      ctx,
      <span style={{ fontSize: "14px" }}>
        {t("自覺症狀，請受檢者依自身實際症狀填選。")}
        <br />
        {t("註：")}
        <br />
        <span style={{ color: color }}>{t("呼吸困難1：")}</span>
        {t("係指與相同年齡之健康者同樣能工作、步行、上坡、及上下樓梯者。")}
        <br />
        <span style={{ color: color }}>{t("呼吸困難2：")} </span>
        {t("係指與相同年齡之健康者同樣能步行但不能上坡及上樓梯者。")}
        <br />
        <span style={{ color: color }}>{t("呼吸困難3：")}</span>
        {t(
          "係指與相同年齡之健康者在平地不能同樣步行，但以自己步速能步行一公里以上者。"
        )}
        <br />
        <span style={{ color: color }}>{t("呼吸困難4：")}</span>
        {t("係指繼續步行五十公尺以上即須停頓者。")}
        <br />
        <span style={{ color: color }}>{t("呼吸困難5：")}</span>
        {t("係指因說話、換衣就有呼吸困難，因此不能走出屋外者。")}
      </span>
    );
  }
};

export default UcOptionLabel;
